<!-- New Chat Add User Form Section -->

<div class="col th-p">
  <div class="contents is-marginless">
    <div class="scroll-bar">
      <div class="column">
        <div class="columns">
          <div class="column is-half is-offset-one-quarter">
            <div class="columns new-chat mar-top15">
              <div class="column">
                <div class="card">
                  <div class="card-content">
                    <div class="content form-style">
                      <h3>New Conversation</h3>

                      <div class="columns">
                        <div class="column is-12">
                          <div class="field">
                            <div class="control has-icons-left has-icons-right">
                              <input
                                class="input"
                                type="text"
                                placeholder="Search Here..."
                                [(ngModel)]="search"
                                (keyup)="searchSubject.next($event)"
                              />
                              <!-- (keyup.enter)="searchUserList(search,tabName)"> -->
                              <span class="icon is-small is-left">
                                <i class="fa fa-search"></i>
                              </span>
                              <span class="icon is-small is-right">
                                @if (search) {
                                <i
                                  class="fa fa-close"
                                  (click)="clearSearchUserList()"
                                ></i>
                                }
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- field -->
                      <div class="tabs is-boxed">
                        <ul>
                          <li
                            class=""
                            [ngClass]="{ 'is-active': tabName == 'all_user' }"
                            (click)="switchNewChatTab('all_user')"
                          >
                            <a> All Users </a>
                          </li>
                          <li
                            class=""
                            [ngClass]="{
                              'is-active': tabName == 'frequent_user'
                            }"
                            (click)="switchNewChatTab('frequent_user')"
                          >
                            <a> Frequent Conversation Users </a>
                          </li>
                        </ul>
                      </div>

                      <!-- <div class="columns userList" [style.display]="tabName=='all_user' ?'inherit':'none'"> -->
                      @if (tabName=='all_user') {
                      <div class="columns userList">
                        <div class="column">
                          <div
                            class="field pos-relative scroll-bar"
                            infinite-scroll
                            [infiniteScrollDistance]="modalScrollDistance"
                            [infiniteScrollThrottle]="modalScrollThrottle"
                            [scrollWindow]="false"
                            (scrolled)="fetchNextUserList()"
                          >
                            <div class="panel">
                              @if (userList.length > 0) { @for (user of
                              userList; track user) {
                              <label
                                class="panel-block pos-relative"
                                [ngClass]="{
                                  'active-bg':
                                    userIdList.indexOf(user.user_id) > -1
                                }"
                                (click)="selectedUser(user.user_id)"
                              >
                                <div class="chat-user-status">
                                  @if (!user.user_icon) {
                                  <empty-uname
                                    [userName]="user.first_name"
                                    [liProfile]="true"
                                  ></empty-uname>
                                  } @if (user.user_icon) {
                                  <img
                                    [src]="profileUrl + user.user_icon"
                                    class="image is-48x48"
                                  />
                                  }
                                  <span class="icon is-small">
                                    <i
                                      class="fa fa-circle"
                                      [ngClass]="{
                                        'circle-grey': user.user_status === 0,
                                        'circle-green': user.user_status === 1,
                                        'circle-red': user.user_status === 2,
                                        'circle-yellow': user.user_status === 3
                                      }"
                                    ></i>
                                  </span>
                                </div>
                                <div class="mar-0-10">
                                  <span class="display-b">
                                    {{ user.first_name }}
                                    {{ user.last_name }}</span
                                  >
                                  <!-- <p class="is-size-7 has-text-success" *ngIf="user.is_online">online</p> -->
                                  @if (user.is_online) {
                                  <p
                                    class="is-size-7"
                                    [ngClass]="{
                                      'circle-grey': user.user_status === 0,
                                      'circle-green': user.user_status === 1,
                                      'circle-red': user.user_status === 2,
                                      'circle-yellow': user.user_status === 3
                                    }"
                                  >
                                    {{ user.status_name }}
                                  </p>
                                  } @if (!user.is_online) {
                                  <p class="is-size-7 text-clr-grey">
                                    {{ user.last_seen | amTimeAgo }}
                                  </p>
                                  }
                                </div>
                                @if (userIdList.indexOf(user.user_id) > -1) {
                                <span
                                  class="icon is-small icon-align is-pulled-right"
                                >
                                  <i class="fa fa-check"></i>
                                </span>
                                }
                              </label>
                              } } @else {
                              <label class="pad-5-10">No records found</label>
                              }
                              <pagination-loader
                                [showFetchLoader]="showPaginateSpinner"
                              ></pagination-loader>
                            </div>
                          </div>
                        </div>
                      </div>
                      }

                      <!-- <div class="columns userList" [style.display]="tabName=='frequent_user' ?'inherit':'none'"> -->
                      @if (tabName=='frequent_user') {
                      <div class="columns userList">
                        <div class="column">
                          <div
                            class="field pos-relative scroll-bar"
                            infinite-scroll
                            [infiniteScrollDistance]="modalScrollDistance"
                            [infiniteScrollThrottle]="modalScrollThrottle"
                            [scrollWindow]="false"
                            (scrolled)="fetchNextUserList()"
                          >
                            <div class="panel">
                              @if (frequentUserList.length > 0) { @for (user of
                              frequentUserList; track user) {
                              <label
                                class="panel-block pos-relative"
                                [ngClass]="{
                                  'active-bg':
                                    userIdList.indexOf(user.user_id) > -1
                                }"
                                (click)="selectedUser(user.user_id)"
                              >
                                <!-- <empty-uname [userName]="user.first_name" [liProfile]="true" *ngIf="!user.user_icon"></empty-uname>
                                      <img [src]="profileUrl+user.user_icon" class="image is-48x48" *ngIf="user.user_icon"> -->
                                <div class="chat-user-status">
                                  @if (!user.user_icon) {
                                  <empty-uname
                                    [userName]="user.first_name"
                                    [liProfile]="true"
                                  ></empty-uname>
                                  } @if (user.user_icon) {
                                  <img
                                    [src]="profileUrl + user.user_icon"
                                    class="image is-48x48"
                                  />
                                  }
                                  <span class="icon is-small">
                                    <i
                                      class="fa fa-circle"
                                      [ngClass]="{
                                        'circle-grey': user.user_status === 0,
                                        'circle-green': user.user_status === 1,
                                        'circle-red': user.user_status === 2,
                                        'circle-yellow': user.user_status === 3
                                      }"
                                    ></i>
                                  </span>
                                </div>
                                <div class="mar-0-10">
                                  <span class="display-b">
                                    {{ user.first_name }}
                                    {{ user.last_name }}</span
                                  >
                                  <!-- <p class="is-size-7 mar-t-5 text-clr-grey">{{user.last_seen | amTimeAgo}}</p> -->
                                  @if (user.is_online) {
                                  <p
                                    class="is-size-7"
                                    [ngClass]="{
                                      'circle-grey': user.user_status === 0,
                                      'circle-green': user.user_status === 1,
                                      'circle-red': user.user_status === 2,
                                      'circle-yellow': user.user_status === 3
                                    }"
                                  >
                                    {{ user.status_name }}
                                  </p>
                                  } @if (!user.is_online) {
                                  <p class="is-size-7 text-clr-grey">
                                    {{ user.last_seen | amTimeAgo }}
                                  </p>
                                  }
                                </div>
                                @if (userIdList.indexOf(user.user_id) > -1) {
                                <span
                                  class="icon is-small icon-align is-pulled-right"
                                >
                                  <i class="fa fa-check"></i>
                                </span>
                                }
                              </label>
                              } } @else {
                              <label class="pad-5-10">No records found</label>
                              }
                              <pagination-loader
                                [showFetchLoader]="showPaginateSpinner"
                              ></pagination-loader>
                            </div>
                          </div>
                        </div>
                      </div>
                      } @if (userIdList.length > 1) {
                      <div class="field">
                        <label class="label"
                          >Title
                          <span class="required">*</span>
                        </label>
                        <div class="control">
                          <input
                            class="input"
                            type="text"
                            placeholder="Enter Title"
                            [(ngModel)]="groupName"
                          />
                        </div>
                        <!-- <p class="is-small">If more than one user is selected, it will be considered as a group</p> -->
                      </div>
                      }

                      <div class="columns is-clearfix">
                        <div class="column pad-b-0">
                          @if (userIdList.length <= 1) {
                          <div class="has-text-right is-pulled-right">
                            <button
                              type="button"
                              class="button mar-5"
                              (click)="cancelUser()"
                            >
                              Cancel
                            </button>
                            <button
                              class="button is-link mar-5-0"
                              [disabled]="userIdList.length === 0"
                              (click)="createChat('user')"
                            >
                              Save
                            </button>
                          </div>
                          } @if (userIdList.length > 1) {
                          <div class="has-text-right is-pulled-right">
                            <button
                              type="button"
                              class="button mar-5"
                              (click)="cancelUser()"
                            >
                              Cancel
                            </button>
                            <button
                              class="button is-link mar-5-0"
                              [disabled]="!groupName"
                              (click)="createGroupChat('group')"
                            >
                              Save
                            </button>
                          </div>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- card -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
